module.exports = __webpack_public_path__ + "img/bingo_ball-7.1a290dc1.png";